import { spammer } from 'ducks/entities/schema'

export const spammerApiV1ResponseSchema = {
  spammer,
}

export const spammersApiV1ResponseSchema = {
  spammers: [spammer],
}
